<template>
    <LayoutBase>
        <div class="container">
            <h2>Latest updates</h2>
            <div class="grid">
                <div class="col-md-12 featured" v-for="feature in featured">
                    <post-card-wide :post="feature" :group="feature.group" featured="true"></post-card-wide>
                </div>
            </div>
            <div class="grid">
                <div class="col-md-3" v-for="post in posts">
                    <post-card :post="post" :group="post.group"></post-card>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                posts: [],
                featured: [],
            }
        },
        mounted() {
            this.getHomepagePosts();
        },
        methods: {
            getHomepagePosts() {
                axios.get('/api/homepage').then((response) => {
                    this.posts = response.data.posts;
                    this.featured = response.data.featured;
                }, (response) => {
                    this.error = response;
                });
            },
        }
    }
</script>

<style lang="scss">
    .post{
        .featured-image{
            display: block !important;
            flex: 0 1 auto;
            height: 150px;
            margin-bottom: 16px;
            position: relative;
            background-position: center !important;
            background-origin: border-box !important;
            background-size: cover !important;
            border-radius: 2px;
        }

        .post-content{
            a{
                text-decoration: none;
            }

            h1{
                font-size: 24px;
                margin-bottom: 5px;
            }

            p{
                color: #0000008a;
                font-size: 14px;
                overflow: hidden!important;
                max-height: 60px!important;
                text-overflow: ellipsis!important;
                display: -webkit-box!important;
                -webkit-line-clamp: 3!important;
                -webkit-box-orient: vertical;
            }
        }
    }

    .large-post-container{
        .post{
            .post-content{
                margin-left: 60px;
            }
        }
    }

    .small-post-container{
        .post{
            display: flex!important;
            margin-bottom: 15px;

            .featured-image{
                flex: 0 0 auto;
                width: 100px;
                height: 100px;
                margin-right: 24px;
            }

            .post-content{
                min-width: 0;
                width: 265px;

                h1{
                    margin-top: 0;
                    font-size: 18px;
                }

                p{
                    margin: 5px 0;
                }
            }
        }
    }

    .post-container{
        .post{
            display: flex !important;
            flex-direction: row-reverse;
            margin-bottom: 24px;

            .featured-image{
                flex: 0 0 auto;
                width: 150px;
                height: 150px;
                margin-left: 24px;
            }

            .post-content{
                min-width: 0;
                width: 100%;

                h1{
                    font-size: 24px;
                }
            }
        }
    }
</style>